import { Button, Footer } from "@excalidraw/excalidraw/index";
import React, { useCallback } from "react";
import { useI18n } from "@excalidraw/excalidraw/i18n";
import { useExcalidrawActionManager } from "@excalidraw/excalidraw/components/App";
import { actionPresent } from "@excalidraw/excalidraw/actions";
import { presentIcon } from "@excalidraw/excalidraw/components/icons";

export const AppFooter = React.memo(
  ({ onChange: _onChange }: { onChange: () => void }) => {
    const { t } = useI18n();
    const actionManager = useExcalidrawActionManager();
    const onPresent = useCallback(
      () => actionManager.executeAction(actionPresent),
      [actionManager],
    );

    return (
      <Footer>
        <div className="drawlab-footer-actions">
          <Button
            onSelect={onPresent}
            title={t("labels.present")}
            aria-label={t("labels.present")}
            className="drawlab-present-button"
          >
            {presentIcon}
          </Button>
        </div>
      </Footer>
    );
  },
);
